import { render, staticRenderFns } from "./solicitud-material-detalle-bodega.vue?vue&type=template&id=f0e4afd4"
import script from "./solicitud-material-detalle-bodega.vue?vue&type=script&lang=js"
export * from "./solicitud-material-detalle-bodega.vue?vue&type=script&lang=js"
import style0 from "./solicitud-material-detalle-bodega.vue?vue&type=style&index=0&id=f0e4afd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports